var _radialGradient, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _radialGradient2, _linearGradient20, _radialGradient3, _linearGradient21, _radialGradient4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAtom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "-6 0 512 512.00003",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 225.6181380934,
    cy: 217.295905134,
    gradientUnits: "userSpaceOnUse",
    r: 115.810936037
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4c54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#fc4b53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#f44a51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7377,
    stopColor: "#e6474e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8902,
    stopColor: "#d2434a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be3f45"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d767c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3227,
    stopColor: "#d363c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#c656bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b342ac"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 200.231761695,
    x2: 338.3284610334,
    xlinkHref: "#b",
    y1: 256.00011,
    y2: 256.00011
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b342ac",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2597,
    stopColor: "#a4319c",
    stopOpacity: 0.258824
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7199,
    stopColor: "#8d1885",
    stopOpacity: 0.721569
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#850f7c"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 347.0738263598,
    x2: 319.9764656968,
    xlinkHref: "#d",
    y1: 433.705849103,
    y2: 406.6083880478
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 19.0560665912,
    x2: 480.298893801,
    xlinkHref: "#b",
    y1: 255.9998088234,
    y2: 255.9998088234
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 182.4585273914,
    x2: 174.5452126186,
    xlinkHref: "#d",
    y1: 441.7174478396,
    y2: 408.7449348482
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 215.314183862,
    x2: 292.457558186,
    xlinkHref: "#b",
    y1: 193.337808565,
    y2: 334.0109733242
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 106.7486532912,
    x2: 80.6163628468,
    xlinkHref: "#d",
    y1: 287.0370613754,
    y2: 260.9046705388
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 62.2250137678,
    x2: 85.8105548826,
    xlinkHref: "#d",
    y1: 231.6711646442,
    y2: 255.2568061512
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 148.1308200922,
    x2: 151.807082064,
    xlinkHref: "#d",
    y1: 370.5172917556,
    y2: 318.4006889696
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 141.6295216124,
    x2: 132.967983773,
    xlinkHref: "#d",
    y1: 274.7355031484,
    y2: 327.282085727
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 109.0818684114,
    x2: 143.1189402916,
    xlinkHref: "#d",
    y1: 218.522195857,
    y2: 208.397140526
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: 172.8305138426,
    x2: 132.9270237554,
    xlinkHref: "#d",
    y1: 174.8362288504,
    y2: 186.5920550782
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    gradientUnits: "userSpaceOnUse",
    x1: 312.7828626058,
    x2: 345.809486993,
    xlinkHref: "#d",
    y1: 341.2349952518,
    y2: 334.3339350316
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientUnits: "userSpaceOnUse",
    x1: 383.8289166628,
    x2: 358.4944430318,
    xlinkHref: "#d",
    y1: 319.9043633412,
    y2: 294.5698897102
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientUnits: "userSpaceOnUse",
    x1: 192.9557366078,
    x2: 162.4236576062,
    xlinkHref: "#d",
    y1: 123.7211386516,
    y2: 95.9460302464
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    gradientUnits: "userSpaceOnUse",
    x1: 134.7369947292,
    x2: 169.6281030548,
    xlinkHref: "#d",
    y1: 103.5558593986,
    y2: 111.2542344712
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    gradientUnits: "userSpaceOnUse",
    x1: 449.6904163352,
    x2: 415.3258650986,
    xlinkHref: "#d",
    y1: 295.7700784612,
    y2: 261.4055272246
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    gradientUnits: "userSpaceOnUse",
    x1: 402.667613385,
    x2: 424.8243727094,
    xlinkHref: "#d",
    y1: 234.527724303,
    y2: 256.6843832352
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "u",
    cx: 445.9031205902,
    cy: 357.435384958,
    gradientUnits: "userSpaceOnUse",
    r: 63.9445106134
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4348,
    stopColor: "#ffe346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#ffdc3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7947,
    stopColor: "#ffd032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9254,
    stopColor: "#ffbf1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb211"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    gradientUnits: "userSpaceOnUse",
    x1: 72.3003749598,
    x2: 13.9091592816,
    xlinkHref: "#d",
    y1: 381.4408666454,
    y2: 323.049550575
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "w",
    cx: 26.8832448564,
    cy: 296.440096004,
    gradientUnits: "userSpaceOnUse",
    r: 63.9445106134
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a3ffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4077,
    stopColor: "#a1feff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5545,
    stopColor: "#9afafe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6592,
    stopColor: "#8ff4fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7439,
    stopColor: "#7eeafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8164,
    stopColor: "#68def7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8806,
    stopColor: "#4ccff3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9386,
    stopColor: "#2cbdee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9902,
    stopColor: "#08a9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a5e8"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    gradientUnits: "userSpaceOnUse",
    x1: 337.5157861744,
    x2: 315.936783961,
    xlinkHref: "#d",
    y1: 88.287410485,
    y2: 66.7083078794
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "y",
    cx: 289.908098267,
    cy: 22.797060776,
    gradientUnits: "userSpaceOnUse",
    r: 63.9445106134
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c6e56f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3225,
    stopColor: "#c4e56f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4819,
    stopColor: "#bce36e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6055,
    stopColor: "#afe16d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7107,
    stopColor: "#9cdd6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8042,
    stopColor: "#84d968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8894,
    stopColor: "#66d365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9666,
    stopColor: "#44cc61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32c95f"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m322.425781 256c0 40.175781-32.570312 72.75-72.75 72.75-40.175781 0-72.746093-32.574219-72.746093-72.75s32.570312-72.75 72.746093-72.75c40.179688 0 72.75 32.574219 72.75 72.75zm0 0",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m249.675781 512c-34.871093 0-66.769531-28.003906-89.816406-78.847656-21.550781-47.539063-33.421875-110.453125-33.421875-177.152344s11.871094-129.613281 33.421875-177.152344c23.046875-50.84375 54.945313-78.847656 89.816406-78.847656 34.871094 0 66.769531 28.003906 89.820313 78.847656 21.550781 47.539063 33.417968 110.453125 33.417968 177.152344s-11.867187 129.613281-33.417968 177.152344c-23.050782 50.84375-54.949219 78.847656-89.820313 78.847656zm0-485.714844c-23.59375 0-47.605469 23.113282-65.875 63.417969-20.039062 44.199219-31.074219 103.257813-31.074219 166.296875s11.035157 122.097656 31.074219 166.296875c18.269531 40.304687 42.28125 63.417969 65.875 63.417969 23.597657 0 47.609375-23.113282 65.878907-63.417969 20.039062-44.199219 31.074218-103.257813 31.074218-166.296875s-11.035156-122.097656-31.074218-166.296875c-18.269532-40.304687-42.28125-63.417969-65.878907-63.417969zm0 0",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m344.695312 420.648438-26.28125-4.921876 19.921876 19.921876c.386718-.832032.78125-1.652344 1.164062-2.496094 1.808594-3.992188 3.542969-8.101563 5.214844-12.304688zm0 0",
    fill: "url(#e)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m381.277344 423.542969c-7.363282 0-15.066406-.390625-23.089844-1.179688-51.945312-5.105469-112.363281-26.285156-170.128906-59.636719-57.765625-33.351562-106.316406-75.085937-136.707032-117.515624-32.511718-45.386719-40.8125-87.011719-23.375-117.210938 17.433594-30.199219 57.632813-43.824219 113.191407-38.363281 51.945312 5.105469 112.363281 26.285156 170.128906 59.636719 57.765625 33.351562 106.3125 75.085937 136.707031 117.515624 32.507813 45.386719 40.808594 87.011719 23.375 117.210938-14.914062 25.835938-46.5 39.542969-90.101562 39.542969zm-263.078125-308.789063c-33.472657 0-57.570313 9.261719-67.460938 26.390625-11.796875 20.4375-3.785156 52.785157 21.980469 88.757813 28.261719 39.453125 73.890625 78.542968 128.484375 110.0625 54.589844 31.515625 111.257813 51.488281 159.554687 56.238281 44.03125 4.324219 76.058594-4.910156 87.859376-25.347656 11.796874-20.433594 3.785156-52.785157-21.980469-88.757813-28.261719-39.453125-73.890625-78.539062-128.480469-110.058594-54.59375-31.519531-111.257812-51.492187-159.558594-56.238281-7.125-.703125-13.9375-1.046875-20.398437-1.046875zm0 0",
    fill: "url(#f)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m183.800781 422.296875c-.902343-1.984375-1.988281-4.476563-2.851562-6.523437l-26.5625 4.492187.507812 1.214844c1.59375 3.980469 3.246094 7.878906 4.964844 11.671875 6.722656 14.835937 14.207031 27.707031 22.289063 38.523437l28.902343-6.324219c-9.859375-10.605468-19.125-25.125-27.25-43.054687zm0 0",
    fill: "url(#g)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m118.078125 423.542969c-43.609375 0-75.1875-13.703125-90.101563-39.542969-17.4375-30.199219-9.136718-71.824219 23.371094-117.210938 30.394532-42.429687 78.945313-84.164062 136.710938-117.515624 57.761718-33.351563 118.183594-54.53125 170.125-59.636719 55.566406-5.457031 95.761718 8.164062 113.195312 38.363281s9.132813 71.828125-23.375 117.210938c-30.394531 42.433593-78.941406 84.167968-136.707031 117.515624-57.765625 33.351563-118.183594 54.53125-170.128906 59.636719-8.023438.789063-15.730469 1.179688-23.089844 1.179688zm263.078125-308.789063c-6.464844 0-13.269531.34375-20.398438 1.042969-48.296874 4.75-104.964843 24.722656-159.554687 56.238281-54.59375 31.519532-100.222656 70.609375-128.484375 110.0625-25.765625 35.972656-33.777344 68.320313-21.980469 88.757813 11.800781 20.4375 43.820313 29.671875 87.859375 25.34375 48.296875-4.746094 104.964844-24.71875 159.554688-56.238281 54.59375-31.519532 100.222656-70.605469 128.484375-110.058594 25.765625-35.972656 33.777343-68.324219 21.976562-88.757813-9.886719-17.128906-33.988281-26.390625-67.457031-26.390625zm0 0",
    fill: "url(#h)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m94.101562 256.132812-.085937.003907-16.890625 20.269531.085938.160156c15.414062 16.507813 33.34375 32.601563 53.214843 47.808594l-3.589843-36.386719-.441407-.679687c-11.796875-10.148438-22.617187-20.589844-32.292969-31.175782zm0 0",
    fill: "url(#i)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m72.71875 229.902344c-8.585938-11.984375-15.1875-23.5625-19.753906-34.4375l-19.828125 19.824218c4.84375 9.730469 10.910156 19.730469 18.210937 29.921876 2.453125 3.425781 5.039063 6.847656 7.726563 10.257812l.894531.445312 17.125-20.101562c-1.496094-1.96875-2.964844-3.9375-4.375-5.910156zm0 0",
    fill: "url(#j)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m160.625 345.519531-29.851562-20.902343c2.429687 18.757812 5.847656 36.808593 10.207031 53.839843h27.183593c-2.910156-10.539062-5.429687-21.546875-7.539062-32.9375zm0 0",
    fill: "url(#k)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m152.726562 256c0-3.347656.039063-6.683594.097657-10.007812h-26.289063c-.058594 3.328124-.097656 6.660156-.097656 10.007812 0 10.929688.324219 21.753906.953125 32.425781l28.167969 22.105469.007812-.035156c-1.871094-17.632813-2.839844-35.890625-2.839844-54.496094zm0 0",
    fill: "url(#l)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m86.496094 225.847656 18.574218 18.574219c6.988282-6.972656 14.449219-13.859375 22.347657-20.609375l3.34375-36.445312c-16.136719 12.328124-30.988281 25.238281-44.265625 38.480468zm0 0",
    fill: "url(#m)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m160.566406 166.234375-4.996094 35.375.070313-.019531c10.992187-7.996094 22.570313-15.714844 34.636719-23.066406v-30.515626c-.738282.421876-1.480469.839844-2.21875 1.265626-9.421875 5.441406-18.597656 11.105468-27.492188 16.960937zm0 0",
    fill: "url(#n)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m338.707031 345.820312 5.21875-35.5625c-13.179687 9.59375-27.199219 18.789063-41.894531 27.4375v30.257813c3.09375-1.710937 6.183594-3.445313 9.265625-5.226563 9.394531-5.421874 18.539063-11.070312 27.410156-16.90625zm0 0",
    fill: "url(#o)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m371.992188 288.140625c-.007813.007813-.015626.011719-.023438.019531l-3.398438 36.414063.175782-.058594c7.582031-5.796875 14.882812-11.722656 21.867187-17.75zm0 0",
    fill: "url(#p)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m181.046875 96.308594c-.015625-.003906-.027344-.007813-.042969-.007813l-9.140625 24.792969.082031.09375c14.40625 3.171875 29.285157 7.46875 44.40625 12.8125zm0 0",
    fill: "url(#q)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m110.796875 114.917969c2.414063-.105469 4.878906-.164063 7.402344-.164063 6.460937 0 13.273437.34375 20.398437 1.042969 2.363282.234375 4.753906.511719 7.160156.820313l8.847657-25.320313c-4.535157-.664063-9.019531-1.226563-13.4375-1.660156-10.714844-1.050781-20.851563-1.386719-30.371094-1.039063zm0 0",
    fill: "url(#r)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m448.003906 266.789062c-2.582031-3.605468-5.304687-7.203124-8.144531-10.792968h-.003906l-17.496094 20.324218c1.460937 1.925782 2.894531 3.851563 4.273437 5.777344 11.101563 15.496094 18.894532 30.3125 23.242188 43.800782h27.363281c-4.601562-18.433594-14.382812-38.375-29.234375-59.109376zm0 0",
    fill: "url(#s)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m381.679688 232.414062c8.503906 7.742188 16.433593 15.628907 23.707031 23.597657l16.957031-20.335938-.023438-.050781c-6.863281-7.363281-14.234374-14.640625-22.046874-21.800781zm0 0",
    fill: "url(#t)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m499.355469 378.804688c0 22.183593-17.984375 40.167968-40.167969 40.167968s-40.167969-17.984375-40.167969-40.167968c0-22.183594 17.984375-40.167969 40.167969-40.167969s40.167969 17.984375 40.167969 40.167969zm0 0",
    fill: "url(#u)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m112.097656 423.441406v-26.308594c-30.292968-1.070312-52.082031-10.207031-61.359375-26.277343-5.746093-9.953125-6.777343-22.742188-3.363281-37.394531h-26.871094c-1.144531 6.523437-1.617187 12.839843-1.386718 18.902343l68.644531 68.644531c7.578125 1.367188 15.710937 2.179688 24.335937 2.433594zm0 0",
    fill: "url(#v)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m80.335938 317.808594c0 22.1875-17.984376 40.167968-40.167969 40.167968-22.183594 0-40.167969-17.980468-40.167969-40.167968 0-22.183594 17.984375-40.167969 40.167969-40.167969 22.183593 0 40.167969 17.984375 40.167969 40.167969zm0 0",
    fill: "url(#w)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m312.570312 83.390625 15.324219 15.324219h19.714844c-2.53125-6.875-5.230469-13.511719-8.113281-19.867188-2.765625-6.101562-5.660156-11.867187-8.671875-17.300781h-21.121094c-2.855469 0-5.570313 1.230469-7.449219 3.378906 3.582032 5.605469 7.03125 11.769531 10.316406 18.464844zm0 0",
    fill: "url(#x)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m343.359375 44.167969c0 22.183593-17.984375 40.167969-40.167969 40.167969s-40.167968-17.984376-40.167968-40.167969c0-22.183594 17.984374-40.167969 40.167968-40.167969s40.167969 17.984375 40.167969 40.167969zm0 0",
    fill: "url(#y)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAtom);
export default __webpack_public_path__ + "static/media/icon-atom.7d37fd2c2c8cc8cf5b1d4a5661a00e1b.svg";
export { ForwardRef as ReactComponent };